__turbopack_context__.v({
  "Address": "zFPd8W_Address",
  "AddressIcon": "zFPd8W_AddressIcon",
  "AddressIconWrapper": "zFPd8W_AddressIconWrapper",
  "AddressLabel": "zFPd8W_AddressLabel",
  "Buttons": "zFPd8W_Buttons",
  "CloseButton": "zFPd8W_CloseButton",
  "ContentButton": "zFPd8W_ContentButton",
  "CountryList": "zFPd8W_CountryList",
  "DesktopOnly": "zFPd8W_DesktopOnly",
  "Details": "zFPd8W_Details",
  "DetailsHeader": "zFPd8W_DetailsHeader",
  "DetailsHeaderButton": "zFPd8W_DetailsHeaderButton",
  "DetailsHeaderButtons": "zFPd8W_DetailsHeaderButtons",
  "DetailsHoldingCarousel": "zFPd8W_DetailsHoldingCarousel",
  "DetailsHoldingCarouselButton": "zFPd8W_DetailsHoldingCarouselButton",
  "DetailsHoldingCarouselButtons": "zFPd8W_DetailsHoldingCarouselButtons",
  "DetailsHoldingCarouselCounter": "zFPd8W_DetailsHoldingCarouselCounter",
  "DetailsHoldingTagWrapper": "zFPd8W_DetailsHoldingTagWrapper",
  "DetailsHoldings": "zFPd8W_DetailsHoldings",
  "DetailsHoldingsHeader": "zFPd8W_DetailsHoldingsHeader",
  "DetailsIconWrapper": "zFPd8W_DetailsIconWrapper",
  "DetailsWrapper": "zFPd8W_DetailsWrapper",
  "GuoTitle": "zFPd8W_GuoTitle",
  "Layers": "zFPd8W_Layers",
  "LoadingContent": "zFPd8W_LoadingContent",
  "LoadingText": "zFPd8W_LoadingText",
  "Map": "zFPd8W_Map",
  "MapLoadingOverlay": "zFPd8W_MapLoadingOverlay",
  "MapWrapper": "zFPd8W_MapWrapper",
  "MobileOnly": "zFPd8W_MobileOnly",
  "Popup": "zFPd8W_Popup",
  "PopupButton": "zFPd8W_PopupButton",
  "PopupCarousel": "zFPd8W_PopupCarousel",
  "PopupCarouselButton": "zFPd8W_PopupCarouselButton",
  "PopupCarouselButtonWrapper": "zFPd8W_PopupCarouselButtonWrapper",
  "PopupCarouselContent": "zFPd8W_PopupCarouselContent",
  "PopupCarouselContentWrapper": "zFPd8W_PopupCarouselContentWrapper",
  "PopupCarouselContentWrapper--HasTag": "zFPd8W_PopupCarouselContentWrapper--HasTag",
  "PopupCarouselCounter": "zFPd8W_PopupCarouselCounter",
  "PopupCarouselDescription": "zFPd8W_PopupCarouselDescription",
  "PopupCarouselIcon": "zFPd8W_PopupCarouselIcon",
  "PopupCarouselLabel": "zFPd8W_PopupCarouselLabel",
  "PopupCarouselLinkWrapper": "zFPd8W_PopupCarouselLinkWrapper",
  "PopupCarouselTag": "zFPd8W_PopupCarouselTag",
  "PopupCarouselTagWrapper": "zFPd8W_PopupCarouselTagWrapper",
  "PopupCarouselTitle": "zFPd8W_PopupCarouselTitle",
  "PopupContent": "zFPd8W_PopupContent",
  "PopupDescription": "zFPd8W_PopupDescription",
  "PopupIcon": "zFPd8W_PopupIcon",
  "PopupInfo": "zFPd8W_PopupInfo",
  "PopupLabel": "zFPd8W_PopupLabel",
  "PopupLinkButton": "zFPd8W_PopupLinkButton",
  "PopupTag": "zFPd8W_PopupTag",
  "PopupTagWrapper": "zFPd8W_PopupTagWrapper",
  "PopupTitle": "zFPd8W_PopupTitle",
  "PopupWrapper": "zFPd8W_PopupWrapper",
  "Root": "zFPd8W_Root",
  "Root--BottomFlush": "zFPd8W_Root--BottomFlush",
  "Root--FullHeight": "zFPd8W_Root--FullHeight",
  "Root--Holdings": "zFPd8W_Root--Holdings",
  "Root--ListView": "zFPd8W_Root--ListView",
  "Root--ShowDetails": "zFPd8W_Root--ShowDetails",
  "Root--Toolbox": "zFPd8W_Root--Toolbox",
  "ShowWorldMapButton": "zFPd8W_ShowWorldMapButton",
  "StatsSkeletonCard": "zFPd8W_StatsSkeletonCard",
  "StatsSkeletonChip": "zFPd8W_StatsSkeletonChip",
  "StatsSkeletonChipRow": "zFPd8W_StatsSkeletonChipRow",
  "StatsSkeletonTitle": "zFPd8W_StatsSkeletonTitle",
  "StatsSkeletonValue": "zFPd8W_StatsSkeletonValue",
  "TabContent": "zFPd8W_TabContent",
  "TabContentItem": "zFPd8W_TabContentItem",
  "TabContentItemDescription": "zFPd8W_TabContentItemDescription",
  "TabContentItemLabel": "zFPd8W_TabContentItemLabel",
  "TabContentItemTitle": "zFPd8W_TabContentItemTitle",
  "skeleton-loading": "zFPd8W_skeleton-loading",
});
